// Import model
import { StartProjectAddTaskRequest } from '../models/StartProjectAddTaskRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartProjectAddTaskRequest - handles JSON serialization and deserialization with type validation
 */
export class StartProjectAddTaskRequestSerializer {
  /**
   * Deserializes a JSON string into a StartProjectAddTaskRequest instance
   */
  static deserialize(json: string): StartProjectAddTaskRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartProjectAddTaskRequest instance
   */
  static fromObject(obj: any): StartProjectAddTaskRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartProjectAddTaskRequest');
    }


    const instance: StartProjectAddTaskRequest = {
      name: obj['Name'] as string | undefined,
      description: obj['Description'] as string | undefined,
      content: obj['Content'] as string | undefined,
      dueDate: obj['DueDate'] as string | undefined,
      dueTime: obj['DueTime'] as any | undefined,
      assignUserId: obj['AssignUserId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartProjectAddTaskRequest instances
   */
  static deserializeArray(json: string): StartProjectAddTaskRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartProjectAddTaskRequest instance to a JSON string
   */
  static serialize(instance: StartProjectAddTaskRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartProjectAddTaskRequest instance to a plain object
   */
  static toObject(instance: StartProjectAddTaskRequest): any {
    return {
      'Name': instance.name,
      'Description': instance.description,
      'Content': instance.content,
      'DueDate': instance.dueDate,
      'DueTime': instance.dueTime,
      'AssignUserId': instance.assignUserId,
    };
  }

  /**
   * Serializes an array of StartProjectAddTaskRequest instances to a JSON string
   */
  static serializeArray(instances: StartProjectAddTaskRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
